import { useState } from "react";
import Popover from "@mui/material/Popover";
import { Checkbox, FormControlLabel } from "@mui/material";
import { faTableCellsLarge } from "@fortawesome/free-solid-svg-icons";

import { DashboardIconButton } from "./DashboardIconButton";
import i18n from "../../i18n";
import { PlacedCard } from "./dashboardLayout";

type DashboardCardsMenuProps = {
  layout: PlacedCard<{ title: string }>[];
  setHidden: (key: string, hidden: boolean) => void;
};

export const DashboardCardsMenu: React.FC<DashboardCardsMenuProps> = ({ layout, setHidden }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (layout.length === 0) return null;

  const hiddenCount = layout.filter(placement => placement.hidden).length;

  return (
    <>
      <DashboardIconButton
        leftIcon={faTableCellsLarge}
        aria-label={hiddenCount > 0 ? i18n.t("frame.cardsHidden", { ns: "dashboard", count: hiddenCount }) : i18n.t("frame.cards", { ns: "dashboard" })}
        aria-haspopup="true"
        aria-expanded={!!anchor}
        onClick={e => setAnchor(e.currentTarget)}
      >
        {hiddenCount > 0 ? <span className="animate-fade-in text-xs font-medium">{i18n.t("frame.hiddenCount", { ns: "dashboard", count: hiddenCount })}</span> : null}
      </DashboardIconButton>

      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <ul
          aria-label={i18n.t("frame.dashboardCards", { ns: "dashboard" })}
          className="flex flex-col px-3 py-2 bg-theme-surface-2 border border-theme-border rounded"
        >
          {layout.map(placement => (
            <li key={placement.key}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={!placement.hidden}
                    onChange={e => setHidden(placement.key, !e.target.checked)}
                    className="!text-theme-text"
                  />
                }
                label={placement.card.title}
                slotProps={{ typography: { className: "!text-theme-text" } }}
              />
            </li>
          ))}
        </ul>
      </Popover>
    </>
  );
};
